export const DATE_WITH_TIME = 'yyyy-MM-dd HH:mm';
export const SHORT_DATE = 'yyyy-MM-dd';
